import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  rehypothecation_flag: {
    name: 'Rehypothecation flag',
    order: 281
  },
  rehypothecated_rate: {
    name: 'Rehypothecated percentage of collateral amount posted to all counterparties',
    order: 282
  }
};

export function FinancingLiquidity3({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.COLLATERAL_FLAGS,
    onChangeFund,
    schema: schema.COLLATERAL_FLAGS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.COLLATERAL_FLAGS?.field_names || [],
    columnLables,
    tableName: 'COLLATERAL_FLAGS',
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="reporttables-financing-liquidity-3-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
